/* tslint:disable:no-string-literal */
import {
  ChangeDetectorRef,
  Component,
  HostListener,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup } from '@angular/forms';
import { WorkflowService } from '../_services/workflow.service';
import { map, switchMap, take } from 'rxjs/operators';
import { BehaviorSubject, forkJoin, Observable, of, Subscription } from 'rxjs';
import { LayoutUtilsService, MessageType } from 'src/app/core/_base/crud';
import { FormioComponent } from 'angular-formio';
import { CreatePatientDialogComponent } from '../../apps/lists/patients/patient-add-dialog/patient-add.dialog.component';
import { select, Store } from '@ngrx/store';
import { AppState } from 'src/app/core/reducers';
import {
  ContactRelationshipModel,
  ContactRelationshipsService,
  selectLastCreatedContact,
  selectLastCreatedPatient,
  selectLastCreatedPrescription,
} from 'src/app/core/lists';
import { CreateContactDialogComponent } from '../../../partials/content/general/contact-add-dialog/contact-add.dialog.component';
import { PrescriptionEditComponent } from '../../apps/lists/patients/_subs/prescription-edit/prescription-edit.component';
import { CancelWorkflowDialogComponent } from '../cancel-workflow-dialog/cancel-workflow-dialog.component';
import { AuthService, currentUser, User } from 'src/app/core/auth';
import { CommentsService } from 'src/app/core/services/comments.service';
import { CommunicationsService } from 'src/app/core/timeline/_services';
import { UserService } from '../../../../core/auth/_services';
import { isEqual, maxBy, uniqWith } from 'lodash-es';
import { EntityRelationshipEditComponent } from '../../apps/lists/doctors/relationships/relationship-edit/entity-relationship-edit.component';
import { FollowUpService } from '../../../../core/services/follow-up.service';
import { GeneralAutocompleteComponent } from '../../../partials/layout/general-autocomplete/general-autocomplete.component';
import { Blocker, Resource } from '../../../../core/models';
import { TemplateType, TransactionType } from '../../../../core/enums';
import { ProcessNavigatorService } from '../../../../core/services/process-navigator.service';
import { ProcessNavViewDialogComponent } from '../../../partials/content/general/process-nav-view-dialog/process-nav-view-dialog.component';
import { BlockerService } from '../../../../core/services/blocker.service';
import { OpenPdfComponent } from '../open-pdf/open-pdf.component';

@Component({
  selector: 'kt-create-workflow-dialog',
  templateUrl: './create-workflow-dialog.component.html',
  styleUrls: ['./create-workflow-dialog.component.scss'],
})
export class CreateWorkflowDialogComponent implements OnInit {
  currentId: number;
  parentId: number;
  rightPanelId: number;
  viewLoading = true;
  loadingAfterSubmit = false;
  form = new FormGroup({});
  model: any = {};
  options = {};
  modelMappedData = { data: {} };
  fields = {};
  isCreate = false;
  formValue = {};
  private workflowResponse: any;
  private isNewWorkflow: any;
  showReadOnlyData: boolean;
  isDone: boolean;
  isLastStep = false;
  readOnlyField: any;
  readOnlyValue: any;
  isLoading: any;
  isSubmitting = false;
  selectingWorkflow = true;
  workflow: any;
  workflowsList: Observable<any>;
  private workflowId: any;
  loadingWorkflowData = false;
  attachments = [];
  index = 0;
  viewAttachments = true;
  newPatient;
  newContact;
  newPrescription;
  keepOpen = true;
  subscriptions: Subscription[] = [];
  comments = [];
  editCommentValue;
  currentUser;
  commentCount: number;
  isSubmittingComment: boolean;
  @ViewChild('formio', { static: false }) formRight: FormioComponent;
  currentStatusNumber: any;
  maxStatusNumber: any;
  loadingHistory = false;
  showMenu = false;
  history = [];
  wqHistory = [];
  wqCommentsHistory = [];
  relatedIds = [];
  isPickedSub = new BehaviorSubject(false);
  doRefresh = new BehaviorSubject(false);
  getAssignToAutocomplete = this.userService.searchUser.bind(this.userService, null);
  @ViewChild('assignToAutocomplete', { static: true })
  assignToAutocomplete: GeneralAutocompleteComponent;
  templateResources$: Observable<Resource[]>;
  templateBlockers$: Observable<Blocker[]>;
  blockersControl: FormControl;

  constructor(
    private contactRelationshipsService: ContactRelationshipsService,
    public dialogRef: MatDialogRef<CreateWorkflowDialogComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private workflowService: WorkflowService,
    private cdr: ChangeDetectorRef,
    private layoutUtilsService: LayoutUtilsService,
    private commentsService: CommentsService,
    private communicationsService: CommunicationsService,
    private followUpService: FollowUpService,
    private userService: UserService,
    private processNavService: ProcessNavigatorService,
    private blockerService: BlockerService,
    private auth: AuthService,
    private store: Store<AppState>,
  ) {
    this.workflow = new FormControl();
  }

  ngOnInit(): void {
    this.getComments();
    const assignedUsersId = uniqWith<number>(
      this.data.workflow.workflow_queue.responsible_users.map(
        (user) => user.responsible_id,
        isEqual,
      ),
    );
    this.isPickedSub.next(assignedUsersId.length > 0);
    if (assignedUsersId.length) {
      this.userService
        .getUsersById(assignedUsersId)
        .pipe(take(1))
        .subscribe(({ pageOfItems }) => {
          if (!pageOfItems.length) return;

          this.assignToAutocomplete.setValue(
            pageOfItems.map((user) => ({ ...user, name: user.userName })),
          );
          this.assignToAutocomplete.updateValueAndValidity();
        });
    }
    const patientSub = this.store
      .pipe(select(selectLastCreatedPatient))
      .subscribe((res) => (this.newPatient = res));
    this.subscriptions.push(patientSub);
    const contactSub = this.store
      .pipe(select(selectLastCreatedContact))
      .subscribe((res) => (this.newContact = res));
    this.subscriptions.push(contactSub);
    const prescriptionSub = this.store
      .pipe(select(selectLastCreatedPrescription))
      .subscribe((res) => (this.newPrescription = res));
    this.subscriptions.push(prescriptionSub);
    this.subscriptions.push(
      this.store.pipe(select(currentUser)).subscribe((res) => (this.currentUser = res.userName)),
    );
    if (this.data.workflowId) {
      this.workflowId = this.data.workflowId;
    }
    if (this.data.workflow) {
      this.currentId = this.data.workflow.workflow_action.id;
      this.parentId = this.data.workflow.workflow_action.parent_id;
      this.attachments = this.data.workflow.workflow_queue.attachments;
    }

    this.isNewWorkflow = this.data.isNew;
    this.isLoading = true;
    this.currentStatusNumber = this.data.statuses.find((e) => e.status === this.getTitle());
    this.maxStatusNumber = maxBy(this.data.statuses, 'number');
    if (
      this.currentStatusNumber &&
      this.maxStatusNumber &&
      'number' in this.currentStatusNumber &&
      'number' in this.maxStatusNumber
    ) {
      const currentNum = Number(this.currentStatusNumber.number);
      const maxNum = Number(this.maxStatusNumber.number);

      if (maxNum === currentNum) {
        this.isDone = true;
      }

      if (maxNum - 1 === currentNum) {
        this.isLastStep = true;
      }
    }
    if (this.isNewWorkflow) {
      this.isCreate = true;
      this.workflowsList = this.workflowService
        .getAvailableWorkflowInGroup(this.workflowId)
        .pipe(map((res) => res.data));
      this.workflow.valueChanges.subscribe(() => {
        this.initCreateWorkflow();
      });
    } else {
      this.workflowId = this.data.workflow.workflow_action.workflow_id;
      this.initUpdateWorkflow();
    }

    if (this.isNewWorkflow) {
      this.workflow.valueChanges.subscribe((id: string | null) => {
        // tslint:disable-next-line:max-line-length
        this.workflowId = id;
      });
    }

    this.templateResources$ = this.workflowId
      ? this.processNavService
          .getResources(this.workflowId, TemplateType.WORKFLOW)
          .pipe(map((res) => res.data.filter((resource) => resource.path)))
      : of([]);

    this.templateBlockers$ = this.workflowId
      ? this.blockerService.getBlockers(this.workflowId, TemplateType.WORKFLOW)
      : of([]);

    this.blockersControl = new FormControl(this.data.workflow?.blockers || []);
  }

  onSubmit(moveToNext) {
    this.isSubmitting = true;
    const body = {
      form_schema: JSON.stringify(this.fields),
      input_data: JSON.stringify(this.model),
      move_to_next: moveToNext,
      workflow_action_id: this.workflowResponse.data.id,
      responsible_users: this.assignToAutocomplete.value?.map((user) => ({
        responsible_id: user.id,
      })),
    };

    if (!this.isCreate) {
      body['workflow_queue_id'] = this.data.workflow.workflow_queue.id;
    }

    if ((moveToNext && this.formRight.formio.checkValidity()) || !moveToNext) {
      this.workflowService.saveStepData(body, this.workflowId).subscribe(
        (res) => {
          if (
            this.workflowResponse.data.apis !== null &&
            this.workflowResponse.data.apis.length > 0
          ) {
            const observables = [];
            const startWorkflowApis = this.workflowResponse.data.apis.filter(
              (api) => api.execution_type === 'startWorkflow',
            );
            if (startWorkflowApis.length > 0) {
              this.executeStartWorkflowApis(startWorkflowApis);
            }
            const apis = moveToNext
              ? this.workflowResponse.data.apis.filter(
                  (api) =>
                    api.execution_type === 'SaveAndNext' ||
                    api.execution_type === 'SaveANDSaveAndNext',
                )
              : this.workflowResponse.data.apis.filter(
                  (api) =>
                    api.execution_type === 'SAVE' || api.execution_type === 'SaveANDSaveAndNext',
                );
            if (apis.length > 0) {
              for (const api of apis) {
                if (
                  api.condition === undefined ||
                  api.condition === null ||
                  this.canExecuteAPI(this.model, api.condition)
                ) {
                  if (
                    this.workflowResponse.data.status === 'NOTIFY CLIENT' &&
                    api.url.includes(
                      'timeline/companies/13/communication?communication_type=data.communicationType',
                    )
                  ) {
                    this.sendToPharmacyEmail(api, res);
                  } else {
                    observables.push(
                      this.workflowService.executeApi(
                        api.http_method,
                        api.url,
                        api.payload,
                        this.model,
                        this.data.workflow.workflow_queue.id,
                        this.data.workflow.workflow_queue.received_id,
                      ),
                    );
                  }
                }
              }
              if (observables.length > 0) {
                forkJoin(observables).subscribe(() => {
                  this.close({
                    reloadWorkflow: true,
                    workflow_action_id: this.keepOpen ? res.data.workflow_action_id : null,
                    workflow_queue_id: this.keepOpen ? res.data.workflow_queue_id : null,
                  });
                });
              } else {
                this.close({
                  reloadWorkflow: true,
                  workflow_action_id: this.keepOpen ? res.data.workflow_action_id : null,
                  workflow_queue_id: this.keepOpen ? res.data.workflow_queue_id : null,
                });
              }
            } else {
              this.close({
                reloadWorkflow: true,
                workflow_action_id: this.keepOpen ? res.data.workflow_action_id : null,
                workflow_queue_id: this.keepOpen ? res.data.workflow_queue_id : null,
              });
            }
          } else {
            this.close({
              reloadWorkflow: moveToNext,
              workflow_action_id: this.keepOpen ? res.data.workflow_action_id : null,
              workflow_queue_id: this.keepOpen ? res.data.workflow_queue_id : null,
            });
          }
        },
        () => {
          this.layoutUtilsService.showActionNotification(
            'someone else opening the card will reload the view',
            MessageType.Read,
            3000,
            false,
            false,
          );
          setTimeout(() => {
            this.close(
              {
                reloadWorkflow: true,
              },
              false,
            );
          }, 1000);
        },
      );
    } else {
      this.isSubmitting = false;
      const errMsg = 'Invalid Form Submission. Please check before submitting again';
      this.layoutUtilsService.showActionNotification(
        errMsg,
        MessageType.Delete,
        3000,
        false,
        false,
      );
    }
  }

  private initCreateWorkflow() {
    this.isCreate = true;
    this.loadingWorkflowData = true;
    this.workflowService.getWorkflowsStepData(0, 0, this.workflow.value).subscribe((response) => {
      this.workflowResponse = response;
      this.fields = JSON.parse(response.data.form.schema);
      this.isLoading = false;
      this.loadingWorkflowData = false;
    });
  }

  private initUpdateWorkflow() {
    this.loadingWorkflowData = true;
    // tslint:disable-next-line:max-line-length
    if (!this.isDone) {
      // tslint:disable-next-line:max-line-length
      this.workflowService
        .getWorkflowsStepData(
          this.data.workflow.workflow_action.id,
          this.data.workflow.workflow_queue.id,
          this.workflowId,
        )
        .subscribe(
          (response) => {
            this.showReadOnlyData = true;
            this.isLoading = false;
            this.loadingWorkflowData = false;
            this.rightPanelId = response.data.parent_id;
            this.prepareReadOnlyData();
            this.workflowResponse = response;
            this.fields = JSON.parse(response.data.form.schema);
            this.prepareOldData();
            this.onLockWorkflowClick();
          },
          () => {
            // tslint:disable-next-line:max-line-length
            this.layoutUtilsService.showActionNotification(
              'someone else opening the card will reload the view',
              MessageType.Read,
              3000,
              false,
              false,
            );
            setTimeout(() => {
              this.close(
                {
                  reloadWorkflow: true,
                  workflow_action_id: null,
                  workflow_queue_id: null,
                },
                false,
              );
            }, 1000);
          },
        );
    } else {
      this.rightPanelId = this.currentId;
      this.showReadOnlyData = true;
      this.isLoading = false;
      this.loadingWorkflowData = false;
      this.prepareReadOnlyData();
    }
  }

  private prepareReadOnlyData() {
    const jsonObject = JSON.parse(this.data.workflow.form_schema);
    const jsonValue = JSON.parse(this.data.workflow.input_data);
    this.readOnlyField = jsonObject;
    this.readOnlyValue = { data: jsonValue };
    this.cdr.detectChanges();
  }

  changeReadOnlyForm(direction) {
    const action_id = direction === 'PREV' ? this.parentId : this.currentId;
    this.workflowService
      .getWorkflowsStepData(
        action_id,
        this.data.workflow.workflow_queue.id,
        this.workflowId,
        direction,
      )
      .subscribe((res) => {
        this.readOnlyField = JSON.parse(res.data.form.schema);
        this.readOnlyValue = { data: JSON.parse(res.data.input_data) };
        this.currentId = res.data.id;
        this.parentId = res.data.parent_id;
        this.cdr.detectChanges();
      });
  }

  onChange(event) {
    if (event.data) this.model = event.data;
  }

  private prepareOldData() {
    // first step to map from old form

    if (!this.workflowResponse.data.input_data && this.workflowResponse.data.mapping_template) {
      const mapping = JSON.parse(this.workflowResponse.data.mapping_template.template);
      mapping.forEach((item) => {
        this.modelMappedData.data[item.destination] = this.readOnlyValue.data[item.source];
      });
    }
    // second step to map from server

    const jsonData = JSON.parse(this.workflowResponse.data.input_data);
    // tslint:disable-next-line:forin
    for (const attr in jsonData) {
      this.modelMappedData.data[attr] = jsonData[attr];
    }
  }

  /**
   * Close dialog
   */
  onCancelClick(): void {
    this.close({
      reloadWorkflow: this.doRefresh.value,
    });
  }

  getFullName(obj) {
    return obj.first_name + ' ' + obj.last_name;
  }

  displayContact(entity: any) {
    if (entity) {
      return entity.first_name + ' ' + entity.last_name;
    }
  }

  Next() {
    if (this.index < this.attachments.length) {
      this.index++;
    }
  }

  Previous() {
    if (this.index > 0) {
      this.index--;
    }
  }

  getTitle() {
    return this.data.workflow.workflow_action.status;
  }

  handleFormEvent(event) {
    switch (event.type) {
      case 'addPatient':
        this.openPatientAddDialog();
        break;
      case 'addContact':
        this.openContactAddDialog();
        break;
      case 'addPrescription':
        this.openPrescriptionAddDialog();
        break;
      case 'addContactRelation':
        this.openContactRelationAddDialog();
        break;
      default:
        break;
    }
  }

  openPatientAddDialog() {
    const dialogRef = this.dialog.open(CreatePatientDialogComponent, {
      width: '40vw',
      disableClose: true,
      hasBackdrop: false,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.added) {
        this.modelMappedData.data[`patient`] = this.newPatient;
        this.modelMappedData = { data: this.modelMappedData.data };
      }
    });
  }

  openContactAddDialog() {
    const dialogRef = this.dialog.open(CreateContactDialogComponent, {
      width: '90vw',
      disableClose: true,
      hasBackdrop: false,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.added) {
        this.modelMappedData.data[`contactPerson`] = this.newContact;
        this.modelMappedData = { data: this.modelMappedData.data };
      }
    });
  }

  openContactRelationAddDialog() {
    const dialogRef = this.dialog.open(EntityRelationshipEditComponent, {
      data: {
        contactEntity: false,
        entity_type: 'PATIENT',
        entity_object: null,
      },
      width: '800px',
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.done) {
        const newRel = new ContactRelationshipModel();
        newRel.clear();
        newRel.id = this.modelMappedData.data[`patient_id`];
        newRel.entity_id = this.modelMappedData.data[`patient_id`];
        newRel.entity_type = 'PATIENT';
        newRel.relation_type = result.response.relation_type;
        newRel.relation_type_id = result.response.relation_type_id;
        newRel.relationship_description = result.response.relationship_description;
        newRel.relation_classification = result.response.relation_classification;
        newRel.is_prime = result.response.is_prime;
        newRel.emergency_contact = result.response.emergency_contact;
        newRel.financial_responsible = result.response.financial_responsible;
        newRel.phi_authorized = result.response.phi_authorized;
        this.contactRelationshipsService
          .createEntityRelationship(newRel, result.response.entity_id)
          .subscribe((res: any) => {
            if (!res) {
              return;
            }
            this.modelMappedData.data[`contact`] = res.data;
            this.modelMappedData = { data: this.modelMappedData.data };
          });
      }
    });
  }

  openPrescriptionAddDialog() {
    if (this.modelMappedData.data[`patient`] && this.modelMappedData.data[`patient`][`id`] > 0) {
      const dialogRef = this.dialog.open(PrescriptionEditComponent, {
        data: { patientId: this.modelMappedData.data[`patient`][`id`] },
        width: '40vw',
        disableClose: true,
        hasBackdrop: false,
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result && result.added) {
          this.modelMappedData.data[`medication`] = this.newPrescription;
          this.modelMappedData = { data: this.modelMappedData.data };
        }
      });
    }
  }

  onCancelWorkflowClick() {
    const dialogRef = this.dialog.open(CancelWorkflowDialogComponent, {
      data: {
        workflowQueueId: this.data.workflow.workflow_queue.id,
        inputData: this.model,
        workflowId: this.workflowId,
      },
      width: '600px',
      maxWidth: 'unset !important',
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.cancelled) {
        this.close({
          cancelledWorkflowId: this.workflowId,
        });
      }
    });
  }

  onLockWorkflowClick() {
    this.workflowService.lockWorkflow(this.data.workflow.workflow_queue.id, true).subscribe(() => {
      this.data.workflow.workflow_queue.lock = true;
      // this.layoutUtilsService.showActionNotification('Workflow successfully Locked', MessageType.Read, 3000, false, false);
    });
  }

  close(obj, callLockUnlock = true) {
    if (callLockUnlock && !this.isCreate) {
      this.onUnLockWorkflowClick();
    }
    this.dialogRef.close(obj);
  }

  onUnLockWorkflowClick() {
    this.workflowService.lockWorkflow(this.data.workflow.workflow_queue.id, false).subscribe(() => {
      this.data.workflow.workflow_queue.lock = false;
      // this.layoutUtilsService.showActionNotification('Workflow successfully Locked', MessageType.Read, 3000, false, false);
    });
  }

  cancelAndRecreate() {
    const dialogRef = this.dialog.open(CancelWorkflowDialogComponent, {
      data: {
        workflowQueueId: this.data.workflow.workflow_queue.id,
        recreate: true,
        inputData: this.model,
        workflowId: this.workflowId,
      },
      width: '600px',
      maxWidth: 'unset !important',
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.cancelled) {
        this.workflowService
          .getFirstAction(this.workflowId, this.data.workflow.workflow_queue.id)
          .subscribe((res1) => {
            const firstAction = res1.data;
            const body = {
              form_schema: firstAction.form.schema,
              input_data: firstAction.input_data,
              move_to_next: true,
              workflow_action_id: firstAction.id,
              old_workflow_queue_id: this.data.workflow.workflow_queue.id,
              received_id: this.data.workflow.workflow_queue.received_id,
            };
            this.workflowService.saveStepData(body, this.workflowId).subscribe((res2) => {
              const newItem = {
                id: this.data.workflow.workflow_queue.received_id,
                workflow_id: this.workflowId,
                workflow_queue_id: res2.data.workflow_queue_id,
              };
              const observables = [];
              if (this.data.workflow.workflow_queue.received_id) {
                observables.push(this.workflowService.updateItem(newItem));
              }
              observables.push(
                this.workflowService.postAttachments(
                  newItem.workflow_queue_id,
                  this.data.workflow.workflow_queue.attachments,
                ),
              );
              if (firstAction.apis !== null && firstAction.apis.length > 0) {
                for (const api of firstAction.apis) {
                  if (
                    api.condition === undefined ||
                    api.condition === null ||
                    this.canExecuteAPI(JSON.parse(firstAction.input_data), api.condition)
                  ) {
                    observables.push(
                      this.workflowService.executeApi(
                        api.http_method,
                        api.url,
                        api.payload,
                        JSON.parse(firstAction.input_data),
                        res2.data.workflow_queue_id,
                        0,
                      ),
                    );
                  }
                }
              }
              forkJoin(observables).subscribe(() => {
                this.workflowService
                  .cancelWorkflow(this.data.workflow.workflow_queue.id, result.reason)
                  .subscribe(() => {
                    this.close({
                      reloadWorkflow: true,
                      workflow_action_id: firstAction.id,
                      workflow_queue_id: newItem.workflow_queue_id,
                    });
                  });
              });
            });
          });
      }
    });
  }

  loadOldWorkflowData() {
    this.workflowService
      .getWorkflowsStepData(
        this.workflowResponse.data.id,
        this.data.workflow.workflow_queue.old_workflow_queue_id,
        this.workflowId,
        'CURRENT',
      )
      .subscribe((res) => {
        if (res.data && res.data.input_data !== null) {
          this.modelMappedData = { data: JSON.parse(res.data.input_data) };
        }
      });
  }

  executeStartWorkflowApis(apis) {
    for (const api of apis) {
      if (
        api.condition === undefined ||
        api.condition === null ||
        this.canExecuteAPI(this.model, api.condition)
      ) {
        const workflowId = parseInt(api.url.substring(api.url.lastIndexOf('/') + 1), 10);
        this.workflowService.getFirstAction(workflowId, null).subscribe((res1) => {
          const firstAction = res1.data;
          this.workflowService
            .executeApi(api.http_method, api.url, api.payload, this.model, 0, 0)
            .subscribe((res2) => {
              if (firstAction.apis !== null && firstAction.apis.length > 0) {
                const observables = [];
                for (const firstActionApi of firstAction.apis) {
                  if (
                    firstActionApi.condition === undefined ||
                    firstActionApi.condition === null ||
                    this.canExecuteAPI(this.model, firstActionApi.condition)
                  ) {
                    observables.push(
                      this.workflowService.executeApi(
                        firstActionApi.http_method,
                        firstActionApi.url,
                        firstActionApi.payload,
                        this.model,
                        res2.data.workflow_queue_id,
                        0,
                      ),
                    );
                  }
                }
                forkJoin(observables).subscribe();
              }
            });
        });
      }
    }
  }

  toggleMenu(event) {
    event.stopPropagation();

    if (!this.showMenu) {
      this.getHistory();
    }

    this.showMenu = !this.showMenu;
  }

  @HostListener('window:click', [])
  closeMenu() {
    this.showMenu = false;
  }

  getHistory() {
    let history = [];
    let wqHistory = [];
    let wqCommentsHistory = [];
    let users = [];
    const wqId = this.data.workflow.workflow_queue.id;

    this.loadingHistory = true;

    if (!wqId) {
      this.history = [];
      this.wqHistory = [];
      this.wqCommentsHistory = [];
      this.loadingHistory = false;

      return;
    }

    this.workflowService
      .getHistory(wqId)
      .pipe(
        switchMap((res) => {
          wqHistory = res.wqHistory.data;
          wqCommentsHistory = res.wqCommentsHistory.data;

          wqHistory.forEach((record) => {
            users.push(record.username);
            record.isComment = false;
            record.form_schema =
              typeof record.form_schema === 'string'
                ? JSON.parse(record.form_schema)
                : record.form_schema;
            record.input_data =
              typeof record.input_data === 'string'
                ? { data: JSON.parse(record.input_data) }
                : { data: record.input_data };
          });

          wqCommentsHistory.forEach((record) => {
            users.push(record.username);
            record.isComment = true;
          });

          users = [...new Set(users)];

          return users.length ? this.userService.getUserByUserName(users) : of({ pageOfItems: [] });
        }),
      )
      .subscribe(
        (res) => {
          const workflowQueue = this.data.workflow.workflow_queue;

          users = res.pageOfItems;
          history = [...wqHistory, ...wqCommentsHistory].sort((a, b) =>
            a.rev_timestamp > b.rev_timestamp ? -1 : 1,
          );

          history.forEach((record) => {
            const matchedUser =
              users.length && users.find((user) => user.userName === record.username);

            record.profileUrl = matchedUser ? matchedUser.profileUrl : '';
            record.name = workflowQueue
              ? `${workflowQueue.workflow.name} ${workflowQueue.created}`
              : '';
          });

          this.history = history;
          this.wqHistory = wqHistory;
          this.wqCommentsHistory = wqCommentsHistory;
          this.loadingHistory = false;
        },
        () => {
          this.loadingHistory = false;
        },
      );
  }

  getComments() {
    let users = [];
    let resultOfCOmment = [];

    this.commentsService
      .getComments('workflow_queues', this.data.workflow.workflow_queue.id)
      .subscribe((res) => {
        if (res && res.data) {
          resultOfCOmment = res.data;
          for (const c of resultOfCOmment) {
            c.editMode = false;
            users.push(c.last_modified_user);
          }
          this.commentCount = res.count;
        }
        if (users.length > 0)
          this.userService.getUserByUserName(users).subscribe((result) => {
            if (result.code === 200) {
              users = result.pageOfItems;
              for (const c of resultOfCOmment) {
                c.userName = c.last_modified_user;
                for (const x of users) {
                  if (x.userName === c.last_modified_user) {
                    c.profileUrl = x.profileUrl;
                  }
                }
              }
              this.comments = resultOfCOmment;
              this.comments.sort((a: any, b: any) => {
                return new Date(b.updated).getTime() - new Date(a.updated).getTime();
              });
            }
          });
      });
  }

  sendToPharmacyEmail(api, res) {
    const attachments = this.attachments.filter((a) => a.uuid.includes('.pdf'));
    const arr = attachments.map((a) => a.uuid.substring(a.uuid.lastIndexOf('/') + 1));
    this.workflowService
      .executeApi(
        api.http_method,
        api.url,
        api.payload,
        this.model,
        this.data.workflow.workflow_queue.id,
        this.data.workflow.workflow_queue.received_id,
        arr,
      )
      .subscribe(async (result) => {
        if (result.data) {
          const obs = [];
          for (const [i, url] of result.data.pre_signed_urls.entries()) {
            const file = await fetch(attachments[i].url)
              .then((r) => r.blob())
              .then((blobFile) => new File([blobFile], arr[i], { type: 'application/pdf' }));
            obs.push(this.communicationsService.uploadFiles(url.url, file));
          }
          forkJoin(obs).subscribe(() => {
            const uuids = result.data.pre_signed_urls.map((a) => a.uuid);
            this.communicationsService.sendFiles(result.data.id, uuids).subscribe(() => {
              this.close({
                reloadWorkflow: true,
                workflow_action_id: this.keepOpen ? res.data.workflow_action_id : null,
                workflow_queue_id: this.keepOpen ? res.data.workflow_queue_id : null,
              });
            });
          });
        }
      });
  }

  canExecuteAPI(data: any, conditionStr: string) {
    try {
      const stack = [];
      const array = conditionStr.split(';');
      array.forEach((item) => {
        item = item.trim();
        if (item.startsWith('{')) {
          stack.push(this.evaluateCondition(data, JSON.parse(item)));
        } else {
          const a = stack.pop();
          const b = stack.pop();
          let c;
          switch (item) {
            case '&&':
              c = a && b;
              break;
            case '||':
              c = a || b;
              break;
          }
          stack.push(c);
        }
      });
      const res = stack.pop();
      return typeof res === 'boolean' ? res : false;
    } catch (e) {
      return false;
    }
  }

  getDescendantProp(obj, desc) {
    const arr = desc.split('.');
    while (arr.length) {
      obj = obj[arr.shift()];
    }
    return obj;
  }

  evaluateCondition(data, obj) {
    const a = this.getDescendantProp(data, obj[`field`]);
    const b = obj[`value`];
    switch (obj[`op`]) {
      case '=':
        return a === b;
      case '>':
        return a > b;
      case '<':
        return a < b;
      case '>=':
        return a >= b;
      case '<=':
        return a <= b;
      case '!=':
        return a !== b;
    }
  }

  getWorkflowName() {
    return this.data.workflow.workflow_queue.workflow.name;
  }
  getEntities() {
    const current = this.data.workflow.workflow_queue.workflow_queue_entities;
    current.forEach((element) => {
      this.relatedIds = this.relatedIds.concat(element.ids);
      this.relatedIds = this.arrayUnique(this.relatedIds);
    });
    return this.relatedIds;
  }
  arrayUnique(array) {
    const a = array.concat();
    for (let i = 0; i < a.length; ++i) {
      for (let j = i + 1; j < a.length; ++j) {
        if (a[i] === a[j]) a.splice(j--, 1);
      }
    }
    return a;
  }
  openFollowUpDialog() {
    const data = {
      body: this.data.workflow.workflow_queue,
      type: 'WORKFLOW',
      title: this.getWorkflowName(),
      relatedIds: this.getEntities(),
    };
    this.followUpService.openDialog(data);
  }

  formatAssignToOption(user: User): string {
    return user?.fullName || '';
  }

  formatNewAssignTo(user: User): User {
    return user;
  }

  assignSelf(event: Event): void {
    event.stopPropagation();

    this.isPickedSub.next(true);
    this.doRefresh.next(true);
    this.auth
      .getUser()
      .pipe(take(1))
      .subscribe((user) => {
        const requestBody = {
          form_schema: JSON.stringify(this.fields),
          input_data: JSON.stringify(this.model),
          move_to_next: false,
          workflow_action_id: this.workflowResponse.data.id,
          workflow_queue_id: this.data.workflow.workflow_queue.id,
          responsible_users: [...(this.assignToAutocomplete.value || []), user].map((res) => ({
            responsible_id: res.id,
          })),
        };

        this.workflowService.saveStepData(requestBody, this.workflowId).pipe(take(1)).subscribe();
      });
  }

  openProcessNavView(event: Event): void {
    event.stopPropagation();

    this.dialog.open(ProcessNavViewDialogComponent, {
      width: '700px',
      disableClose: true,
      closeOnNavigation: true,
      data: {
        templateType: TemplateType.WORKFLOW,
        templateName: this.data.workflow?.workflow_queue?.workflow?.name,
        transactionId: this.data.workflow?.workflow_queue?.id,
        resources$: this.templateResources$,
      },
    });
  }

  getBlockerClass(index: number): string {
    const labelClasses = [
      'label-light-primary',
      'label-light-success',
      'label-light-danger',
      'label-light-warning',
      'label-light-info',
    ];
    const length = labelClasses.length;

    return labelClasses[(length + index) % length];
  }

  compareBlockersFn(x: Blocker, y: Blocker): boolean {
    return x && y ? x.id === y.id : x === y;
  }

  handleBlockers(): void {
    const blockers = this.blockersControl?.value;

    this.blockerService
      .createUpdateTransactionBlockers(
        this.data.workflow?.workflow_queue?.id,
        TransactionType.WORKFLOW_QUEUE,
        blockers,
      )
      .pipe(take(1))
      .subscribe((res) => {
        if (res && blockers?.filter((blocker) => blocker.trigger_follow_up).length)
          this.openFollowUpDialog();
      });
  }

  openPDF() {
    if (this.viewAttachments && this.attachments.length > 0) {
      const dialogRef = this.dialog.open(OpenPdfComponent, {
        width: '61vw',
        data: { attachments: this.attachments },
      });
      dialogRef.afterClosed().subscribe(() => {
        this.viewAttachments = !this.viewAttachments;
      });
    }
    this.viewAttachments = !this.viewAttachments;
  }
}
